var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPrepAdd = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7419 14.0323V15.9677C22.7419 16.3669 22.4153 16.6935 22.0161 16.6935H16.6935V22.0161C16.6935 22.4153 16.3669 22.7419 15.9677 22.7419H14.0323C13.6331 22.7419 13.3065 22.4153 13.3065 22.0161V16.6935H7.98387C7.58468 16.6935 7.25806 16.3669 7.25806 15.9677V14.0323C7.25806 13.6331 7.58468 13.3065 7.98387 13.3065H13.3065V7.98387C13.3065 7.58468 13.6331 7.25806 14.0323 7.25806H15.9677C16.3669 7.25806 16.6935 7.58468 16.6935 7.98387V13.3065H22.0161C22.4153 13.3065 22.7419 13.6331 22.7419 14.0323ZM30 15C30 23.2863 23.2863 30 15 30C6.71371 30 0 23.2863 0 15C0 6.71371 6.71371 0 15 0C23.2863 0 30 6.71371 30 15ZM27.0968 15C27.0968 8.31653 21.6835 2.90323 15 2.90323C8.31653 2.90323 2.90323 8.31653 2.90323 15C2.90323 21.6835 8.31653 27.0968 15 27.0968C21.6835 27.0968 27.0968 21.6835 27.0968 15Z",
    fill: "#01035E"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPrepAdd, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/prep-add.c2c75546.svg";
export { ForwardRef as ReactComponent };